import React from 'react'
import './Spinner.scss'

const Spinner = ({ size = 'lg' }: { size?: 'lg' | 'sm' | 'md' }) => {
  return (
    <div className={`lds-roller lds-roller-${size}`}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  )
}

export default Spinner